import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EmberObject, { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import FollowingApi from 'mewe/api/following-api';
import { A } from '@ember/array';
import dispatcher from 'mewe/dispatcher';

export default class MwSuggestedProfiles extends Component {

  @service dynamicDialogs;
  @service router;

  @tracked results = A();

  @action
  fetchSuggestions() {
    FollowingApi.suggestions().then((response) => {
      this.results = A(response.results.map((el) => EmberObject.create(el.user)));
    });
  }

  @action
  userClicked(user) {
    this.router.transitionTo('app.publicid', user.publicLinkId);
  }

  @action
  followUser(user, event) {
    event.stopPropagation();

    dispatcher.dispatch('contact', 'followUser',
      { user,
        doneCb: () => {
          this.results.removeObject(user);
        },
      }
    );
  }

}
